import React from 'react'
import { Cnpj, SectionTitle } from '../../../../../components'
import CteParteForm from './CteParteForm'
import RadioGroup from './RadioGroup'
import { avisoTomador746, opcoesTomadorEmissao } from './ctePartes.util'

const estiloDica = { color: 'gray', fontSize: 12 }
const estiloAviso = {
  padding: '8px 12px',
  borderRadius: 3,
  background: '#FFF3CD',
  border: '1px solid #FFEEBA',
  color: '#856404',
  fontSize: '0.85rem',
  marginTop: 8,
}

function renderOpcao({ papel, parte }) {
  if (!parte || !parte.nome) return papel
  return (
    <>
      {papel}: {parte.nome}
      {parte.cnpj_cpf ? (
        <>
          {' · '}
          <Cnpj>{parte.cnpj_cpf}</Cnpj>
        </>
      ) : null}
    </>
  )
}

export default function SecaoTomador({
  form,
  selectedTp,
  onError,
  somenteLeitura = false,
  permitirOutros = true,
  dica = null,
}) {
  const opcoes = opcoesTomadorEmissao(form, { permitirOutros: permitirOutros && !somenteLeitura })
  const aviso746 = avisoTomador746(form)

  return (
    <>
      <div className="p-col-12">
        <SectionTitle title="Tomador do Serviço" />
        <div style={{ marginTop: 5 }}>
          {somenteLeitura ? (
            <div style={{ fontSize: 13 }}>{renderOpcao(opcoes[0] || { papel: 'Remetente' })}</div>
          ) : (
            <RadioGroup
              nome={`${form.idPrefixo}-tomador`}
              vertical={true}
              items={opcoes.map(opcao => ({ value: opcao.value, label: renderOpcao(opcao) }))}
              value={form.tomador}
              onChange={form.setTomador}
            />
          )}
        </div>
        <span style={estiloDica}>
          {dica ||
            'O indicador de IE do tomador é derivado da situação no ICMS da parte escolhida.'}
        </span>
        {aviso746 && <div style={estiloAviso}>{aviso746}</div>}
      </div>

      {!somenteLeitura && form.tomador === '4' && (
        <CteParteForm
          papel={`${form.idPrefixo}-tomador-outros`}
          titulo="Tomador Outros"
          parte={form.tomadorOutros}
          onChange={form.setTomadorOutros}
          ufs={form.ufs}
          selectedTp={selectedTp}
          carregarCidades={form.carregarCidades}
          onError={onError}
          origens={[{ value: 'manual', label: 'Preencher manualmente' }]}
          telefoneObrigatorio={true}
          dica="Quem contrata o frete sem ser remetente, destinatário, expedidor ou recebedor (não pode repetir o CNPJ/CPF de nenhum deles)."
        />
      )}
    </>
  )
}
